import { render, staticRenderFns } from "./RelatedEventsDialog.vue?vue&type=template&id=6b81a986&"
import script from "./RelatedEventsDialog.vue?vue&type=script&lang=js&"
export * from "./RelatedEventsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelatedEventsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports